import { ApiService } from '@/services';
import gql from 'graphql-tag';
import {
  QueryResponse,
  PaginatedResponse,
  Subscription,
  DataLoaderParams,
  Response,
  DeployDTO
} from '@/types';

class SubsriptionService extends ApiService {
  public async getSubscriptions(
    params: DataLoaderParams
  ): Promise<QueryResponse<PaginatedResponse<Subscription>>> {
    const query = gql`
      query subscriptions(
        $first: Int!
        $page: Int!
        $filters: DataLoaderParams
      ) {
        subscriptions(first: $first, page: $page, filters: $filters) {
          data {
            id
            active
            created_at
            plan {
              plan_name
              service {
                id
                slug
                name
                dns_name
              }
            }
            customer {
              id
              name
              email
            }
            deployment {
              id
              subdomain
              status
              version {
                tag
              }
              cluster {
                name
                provider
                zone
              }
            }
          }
          paginatorInfo {
            total
            perPage
            currentPage
            hasMorePages
          }
        }
      }
    `;
    return await this.query<QueryResponse<PaginatedResponse<Subscription>>>({
      query,
      variables: params
    });
  }
}

export const subsriptionSvc: SubsriptionService = new SubsriptionService();
